export default "__VITE_ASSET__CONdWi$X__"